export enum BroadcastChannelType {
  BrowserTabs = 'browser-tabs',
}
